































































import _ from 'lodash';
import { ShowFinally, Message } from 'mycorems-app-shared';
import { HasTaskMixin } from '@/mixins';
import {
  AccountSettings, ListCustomFields, ListCustomFieldsFilters, QPagination, QueryResult,
} from '@/types';
import { update } from '@/account-settings/account-settings';
import repository from '../../email-campaign/email-campaign-repository';
import accountSettingsRepository from '../../account-settings/account-settings-repository';
import ListCustomFieldsToggle from './ListCustomFieldsToggle.vue';

interface Data {
  listCustomFields: ListCustomFields[],
  searchQuery: string | undefined,
  pagination: QPagination,
  columns: object[],
  enabledCustomFields: {[listId: string]: string[]},
  settingsTask: Promise<AccountSettings>|null,
  accountSettings: AccountSettings|null,
  updateTask: Promise<void>|null,
}

export default HasTaskMixin.extend({
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      listCustomFields: [],
      searchQuery: undefined,
      pagination: {
        page: 1,
        rowsPerPage: 5,
        rowsNumber: 0,
      },
      columns: [
        {
          name: 'name',
          align: 'left',
          label: 'List Name',
        },
        {
          name: 'customFields',
          align: 'left',
          label: 'Custom Fields',
        },
      ],
      settingsTask: null,
      accountSettings: null,
      enabledCustomFields: {},
      updateTask: null,
    };
  },
  watch: {
    clientId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
    filters: {
      handler(): void {
        this.loadListCustomFields();
      },
      deep: true,
    },
    enabledCustomFields: {
      handler(): void {
        this.save();
      },
      deep: true,
    },
    updateTask: {
      handler(newTask): void {
        if (!newTask) return;
        this.isLoading = true;
        newTask.finally(() => {
          this.isLoading = false;
        });
      },
      immediate: true,
    },
  },
  computed: {
    totalEnabledCustomFieldsLabel(): string {
      return `${this.allEnabledCustomFields.length} distinct custom
       field${this.allEnabledCustomFields.length > 1 ? 's' : ''} enabled.`;
    },
    limitReached(): boolean {
      return (this.allEnabledCustomFields.length >= 5);
    },
    allEnabledCustomFields(): string[] {
      const customFields: string[] = [];
      _.forIn(this.enabledCustomFields, (listCustomFields: string[]) => {
        listCustomFields.forEach((listCustomField: string) => {
          if (!customFields.includes(listCustomField)) {
            customFields.push(listCustomField);
          }
        });
      });
      return customFields;
    },
    filters(): ListCustomFieldsFilters {
      return {
        name: this.searchQuery,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
      };
    },
  },
  methods: {
    getEnabledCustomFields(listId: string): string[] {
      return this.enabledCustomFields[listId] || [];
    },
    isEnabled(listId: string, customFieldId: string): boolean {
      const customFields = this.enabledCustomFields[listId];
      if (!Array.isArray(customFields) || !customFields.length) return false;
      return customFields.includes(customFieldId);
    },
    enable(listId: string, customFieldId: string): void {
      if (this.isEnabled(listId, customFieldId)) return;
      if (_.isUndefined(this.enabledCustomFields[listId])) {
        this.$set(this.enabledCustomFields, listId, []);
      }
      this.enabledCustomFields[listId].push(customFieldId);
    },
    disable(listId: string, customFieldId: string): void {
      if (!this.isEnabled(listId, customFieldId)) return;
      const index = this.enabledCustomFields[listId].findIndex(cf => cf === customFieldId);
      if (index >= 0) {
        this.enabledCustomFields[listId].splice(index, 1);
      }
    },
    save(): void {
      if (!this.accountSettings) return;
      const settings: AccountSettings = _.cloneDeep(this.accountSettings);
      settings.customFields = this.enabledCustomFields;
      this.updateTask = update(settings);
      this.updateTask.then(() => {
        this.accountSettings = settings;
      });
      this.updateTask.catch(() => {
        this.loadSettings();
      });
    },
    load(): void {
      this.loadSettings();
      this.loadListCustomFields();
    },
    loadSettings(): void {
      this.settingsTask = accountSettingsRepository.find(this.clientId);
      this.settingsTask.then((accountSettings: AccountSettings) => {
        this.accountSettings = accountSettings;
        if (Array.isArray(accountSettings.customFields)) {
          accountSettings.customFields = {}; // PHP returns an array when object is empty.
        }
        this.enabledCustomFields = accountSettings.customFields;
      });
    },
    loadListCustomFields(): void {
      this.task = repository.findListCustomFields(this.clientId, this.filters);
      this.task.then((result: QueryResult) => {
        this.listCustomFields = (result.items as ListCustomFields[]);
        this.pagination.rowsNumber = result.total;
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    ShowFinally,
    Message,
    ListCustomFieldsToggle,
  },
});
